import 'web-animations-js/web-animations-next-lite.min.js';
import moment from 'moment';
window.moment = moment;
import IntlMessageFormat from 'intl-messageformat';
window.IntlMessageFormat = IntlMessageFormat;

